import React from "react";

import { ic_gold_b, ic_silver_b, ic_gold_b_ok, ic_gold_navy } from "styles/img";
import { SERVICE_CODE, STORAGE_KEY } from "constants/index";
import { useLocalStorage } from "../../lib/useLocalStorage";

const TradeHistoryItem = ({ item }) => {
  const [serviceCode] = useLocalStorage(STORAGE_KEY.SERVICE_CODE);
  const op = item.amount >= 0 ? "+" : "";
  const opClassName = item.amount >= 0 ? "plus" : "minus";

  let assetImage = ic_silver_b;
  if (item.asset === "e금") {
    if (serviceCode === SERVICE_CODE.OKINV) {
      assetImage = ic_gold_b_ok;
    } else if (serviceCode === SERVICE_CODE.HANA) {
      assetImage = ic_gold_navy;
    } else {
      assetImage = ic_gold_b;
    }
  }

  let typeClassName = "kind";
  if (serviceCode === SERVICE_CODE.OKINV) {
    if (item.type === "매수") {
      typeClassName += " buy";
    } else if (item.type === "매도") {
      typeClassName += " sell";
    }
  }

  return (
    <li>
      <div className="th01">
        <p className="date">{item.time}</p>
        <span className="left">
          <img src={assetImage} alt={item.asset} />
          <span className={typeClassName}>{item.type}</span>
        </span>
      </div>
      <div className="th02">
        <span className={opClassName}>
          {op}
          {Math.abs(item.amount)} g
        </span>
      </div>
      <div className="th03">
        <span>{item.balance} g</span>
      </div>
    </li>
  );
};

export default TradeHistoryItem;
